import React, { createContext, useContext } from 'react';

export type TSidebarApiState = {
  platformId: string;
  createImageUpload: (file: File) => Promise<{
    signedS3UploadUrl: string;
    waypointTemplateImageId: string;
  }>;
  refreshImageUpload: (waypointImageId: string) => Promise<{
    imageId: string;
    imageUrl: string;
  }>;
};

const SidebarApiContext = createContext<TSidebarApiState | null>(null);

export const useSidebarApiClient = () => useContext(SidebarApiContext)!;

type Props = {
  children: JSX.Element;
  value: TSidebarApiState;
};
export function SidebarApiClientProvider({ value, children }: Props) {
  return <SidebarApiContext.Provider value={value}>{children}</SidebarApiContext.Provider>;
}
